import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setDialogHandle } from "../actions/dialog";
import { NewVenueDialog } from "../components/modal/NewVenueDialog";


export function useNewVenueDialog(history:any) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    function onNewVenue() {
        dispatch(
            setDialogHandle({
                Component: NewVenueDialog,
                ComponentProps: {
                    history:history?.history
                },
                isFormDialog: true,
                dialogTitle: t('signup.newVenue.addNewVenue')
            })
        );
    }

    return { onNewVenue }
}